import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import { DialogTitle, DialogContent } from '@mui/material'
import { useVenti } from 'venti'
import ChangePassword from '../ChangePassword'
import { LoadingBtn } from '../Button'
import { getTheme } from '../../config'
import { TheBigPOSApi } from '../../lib/TheBigPOSClient'
import { useAppContext } from '../AppContext'
import { getErrorMessage } from '../../services/helper'

const theme = getTheme()

const ModalNewUser = () => {
	const ventiState = useVenti()
	const { state } = useAppContext()
	const { user } = state
	const newUser = ventiState.get(theme.storageKeys.newUser)

	const [loading, setLoading] = useState(false)
	const [userPassword, setUserPassword] = useState('')
	const [errorMessage, setErrorMessage] = useState()
	const [disabledSignUpButton, setDisabledSignUpButton] =
		useState(true)

	const handlePasswordChange = async () => {
		setLoading(true)

		try {
			await TheBigPOSApi.changePassword({
				oldPassword: ventiState.get(theme.storageKeys.tempPassword),
				newPassword: userPassword,
			})
			setLoading(false)
			ventiState.set(theme.storageKeys.newUser, false)
		} catch (e) {
			setErrorMessage(
				getErrorMessage(e) ||
					'We encountered an issue while fulfilling the request. Please try again later.'
			)
			setLoading(false)
		}
	}

	return (
		<Dialog
			open={(newUser && user?.isLoggedIn) ?? false}
			aria-labelledby="responsive-dialog-title"
		>
			<DialogTitle>Set Your Password</DialogTitle>
			<DialogContent>
				<div className="mb-2">
					<p className="text-sm sm:text-base dark:text-white">
						It&apos;s important to set a secure password that you will
						remember
					</p>
				</div>
				<ChangePassword
					passwordLabel="Create password"
					confirmPasswordLabel="Confirm password"
					userPassword={userPassword}
					setUserPassword={setUserPassword}
					setConfirmButton={setDisabledSignUpButton}
					hideConfirmPassword
					userEmail={undefined}
					oldPassword={undefined}
					passwordConfirmed={undefined}
					setPasswordConfirmed={undefined}
					email={undefined}
					userProfile={undefined}
				/>
			</DialogContent>
			{errorMessage && (
				<div className="pr-5 pl-5">{errorMessage}</div>
			)}
			<DialogActions className="ml-5 mr-5">
				<div className="flex justify-center items-center">
					<LoadingBtn
						className="mt-5"
						text="Sign up"
						onClick={handlePasswordChange}
						disabled={!disabledSignUpButton || loading}
						loading={loading}
					/>
				</div>
			</DialogActions>
		</Dialog>
	)
}

export default ModalNewUser
